import { type StateTree } from "pinia";
import { TaskModel } from "~~/package/mapper/learning/model/TaskModel";
import type TaskCompleteRequest from "~~/package/apis/learning/request/TaskCompleteRequest";
import { ContestModel } from "~~/package/mapper/contest/model/ContestModel";
import { DirectorCautionReactiveStatusModel } from "~~/package/mapper/director/model/DirectorCautionReactiveStatusModel";
import { DirectorProctoringConfigModel } from "~~/package/mapper/director/model/DirectorProctoringConfigModel";
import { RecorderDataModel } from "~~/package/mapper/recorder/model/RecorderDataModel";
import {
    ProSkillAssureAssessmentModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentModel";
import {
    ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";
import {
    createExternalDirectorState,
    createLevelAssessmentState,
    createProSkillAssureState,
    createTrackInfoState
} from "@/store/learning/state/factories";

export interface LearningAssessmentStoreState extends StateTree {
    assessmentList: TaskModel[];
    assessmentAnswerList: TaskCompleteRequest[];
    isTimeOut: boolean;

    contestId: number;
    contestTitle: string;
    contestEndedAt: string;
    contestTimeIntervalId: number;
    taskTestTemplateId: number;
    contestList: ContestModel[];

    cautionFlag: DirectorCautionReactiveStatusModel;
    proctoringConfig: DirectorProctoringConfigModel;

    recorderQueue: RecorderDataModel[];
    recorderTime: Date[];
    recorderStream: MediaStream | null;
    recorderIntervalIds: number[];

    trackInfo: {
        title: string;
        levelId: string;
        trackLevel: string;
        trackLevelTitle: string;
    };
    levelAssessment: {
        timerIntervalId: number;
    };
    levelAssessmentIdList: number[];
    taskSolveTime: number;
    solvedQuestion: number;

    proSkillAssure: {
        assessmentId: number;
        assessment: ProSkillAssureAssessmentModel;
        myInfo: ProSkillAssureAssessmentMyInfoModel;
        timer: {
            isStart: boolean;
            elapsedTime: number;
            remainingTime: number;
            timerIntervalId: number;
            extensionHistory: { count: number; addedSeconds: number; receivedAt: string }[];
            totalAddedSeconds: number;
            extensionFlashActive: boolean;
        };
        theFirstOpenTabChangeCautionPopup: boolean;
        isCheckedAPIReference: boolean;
    };

    externalDirector: {
        camId: string | null;
        micId: string | null;
    };
}

export const state = (): LearningAssessmentStoreState => ({
    assessmentList: [],
    assessmentAnswerList: [],
    isTimeOut: false,

    contestId: -1,
    contestTitle: "",
    contestEndedAt: "",
    contestTimeIntervalId: -1,
    taskTestTemplateId: -1,
    contestList: [],

    cautionFlag: new DirectorCautionReactiveStatusModel(),
    proctoringConfig: new DirectorProctoringConfigModel(),

    recorderQueue: [],
    recorderTime: [],
    recorderStream: null,
    recorderIntervalIds: [],

    trackInfo: createTrackInfoState(),
    levelAssessment: createLevelAssessmentState(),
    levelAssessmentIdList: [],
    taskSolveTime: 0,
    solvedQuestion: 0,

    proSkillAssure: createProSkillAssureState(),

    externalDirector: createExternalDirectorState()
});
